import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { comparisonRows } from "../data/content";
export function ComparisonTable() {
  return <section className="bg-white px-4 py-14" aria-labelledby="compare-title" data-id="element-28" data-mp="2pnth9b3sxv97">
      <div className="mx-auto max-w-4xl" data-id="element-29" data-mp="2plqh3y8xqlqr">
        <h2 id="compare-title" className="text-center font-heading text-2xl font-bold uppercase" data-id="element-30" data-mp="2ulv2o2opa6nu">The WoodForge difference</h2>
        <p className="mt-2 text-center text-sm text-ink-muted" data-id="element-31" data-mp="3icqp0kae09np">Compare and decide with clear information.</p>
        <div className="mt-8 overflow-x-auto" data-id="element-32" data-mp="3md14qonzeefr">
          <table className="w-full min-w-[520px] border-collapse text-sm" data-id="element-33" data-mp="38ekmc0grazhs">
            <thead data-id="element-34" data-mp="38gfcbt6vxhsq">
              <tr className="border-b border-neutral-200" data-id="element-35" data-mp="3dcmhhjrgip9m">
                <th scope="col" className="py-4 text-left font-heading font-semibold" data-id="element-36" data-mp="3df8pfki9f6sd">Feature</th>
                <th scope="col" className="w-36 bg-peach py-4 font-heading font-bold text-brand" data-id="element-37" data-mp="1x0z0ao671e0h">WoodForge</th>
                <th scope="col" className="w-36 py-4 font-heading font-semibold text-ink-muted" data-id="element-38" data-mp="21vmftxj7yy2x">Others</th>
              </tr>
            </thead>
            <tbody data-id="element-39" data-mp="29wlmoae4qfab">
              {comparisonRows.map(r => <tr key={r} className="border-b border-neutral-100" data-id="element-40" data-mp="29xwv4niisb7r">
                  <th scope="row" className="py-4 text-left font-normal" data-id="element-41" data-mp="2nwebu1a0cng6">{r}</th>
                  <td className="bg-peach py-4 text-center" data-id="element-42" data-mp="2iw8pn0mibt5h">
                    <CheckIcon className="mx-auto h-5 w-5 text-brand" aria-label="Yes" data-id="element-43" data-mp="2ww9sumq8vco4" />
                  </td>
                  <td className="py-4 text-center" data-id="element-44" data-mp="2suxyy50c85a4">
                    <XIcon className="mx-auto h-5 w-5 text-neutral-400" aria-label="No" data-id="element-45" data-mp="2su6dvo4d9py3" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-8" data-id="element-46" data-mp="31o1d6fit4m5t">
          <CtaButton label="Choose WoodForge" data-id="element-47" data-mp="31p2x79hswizo" />
        </div>
      </div>
    </section>;
}